import { Link } from "react-router-dom"
import "./About.css"

const About = () => {
  const skills = [
    { category: "Programming Languages", items: ["JavaScript", "Java", "Python", "HTML/CSS"] },
    { category: "Frameworks & Libraries", items: ["React", "Node.js", "Spring Boot", "Flutter", "Express.js"] },
    { category: "Databases", items: ["MongoDB", "MySQL", "Firebase"] },
    { category: "Tools & Platforms", items: ["Git", "GitHub", "VS Code", "Figma"] },
  ]

  const education = [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "Informatics Institute Of Technology",
      period: "2022 - Present",
      description: "Currently in my second year, focusing on software development, algorithms, and data structures.",
    },
    {
      degree: "Certificate in Computer Science",
      institution: "National Institute of Business Management",
      period: "Jan 2020 - Sep 2020",
      description: ""  // You can add a description if you want
    }
  ]

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About Me</h1>
          <p>Get to know more about me and my background</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img src="/images/about.jpg" alt="Chamuditha Nonis" />
            </div>
            <div className="about-details">
              <h2>Who I Am</h2>
              <p>
                Hello! I'm Chamuditha Nonis, a second-year Computer Science student with a passion for creating
                innovative digital solutions. I specialize in web and mobile application development, constantly
                exploring new technologies and methodologies to enhance my skills.
              </p>
              <p>
                My journey in programming began when I was in high school, where I developed a keen interest in how
                technology can solve real-world problems. This curiosity led me to pursue Computer Science at
                university, where I've been expanding my knowledge and practical skills.
              </p>
              <p>
                I believe in the power of technology to transform lives and businesses. My goal is to create
                applications that are not only functional but also provide exceptional user experiences.
              </p>
              <div className="about-cta">
                <Link to="/contact" className="btn">
                  Get In Touch
                </Link>
                <a href="/Chamuditha.pdf" className="btn btn-outline" target="_blank" rel="noopener noreferrer">
                  Download Resume
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section skills-section">
        <div className="container">
          <h2 className="section-title">My Skills</h2>
          <div className="skills-container">
            {skills.map((skillGroup, index) => (
              <div key={index} className="skill-group">
                <h3>{skillGroup.category}</h3>
                <div className="skill-list">
                  {skillGroup.items.map((skill, idx) => (
                    <span key={idx} className="skill-item">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section education-section">
  <div className="container">
    <h2 className="section-title">Education</h2>
    <div className="timeline">
      {education.map((item, index) => (
        <div key={index} className="timeline-item">
          <div className="timeline-content">
            <h3>{item.degree}</h3>
            <h4>{item.institution}</h4>
            <p className="timeline-period">{item.period}</p>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      <section className="section interests-section">
        <div className="container">
          <h2 className="section-title">My Interests</h2>
          <div className="interests-grid">
            <div className="interest-item">
              <i className="fas fa-laptop-code"></i>
              <h3>Web Development</h3>
              <p>Creating responsive and interactive web applications using modern frameworks.</p>
            </div>
            <div className="interest-item">
              <i className="fas fa-mobile-alt"></i>
              <h3>Mobile Development</h3>
              <p>Building cross-platform mobile apps that provide great user experiences.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About

